import { Box } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import axiosApiInstance from 'src/api/axiosConfig';
import ShsSelectInput from 'src/components/common/Fields/ShsSelectInput';
import { EducationCenterType } from 'src/components/Employees/types';
import { palette } from 'src/Theme';
import { useScheduleCalendarContext } from '../../common/context/CalendarContext';

const fetchEducationCenters = async (): Promise<any> => {
    const { data } = await axiosApiInstance.get(`centers`);

    return data;
};

export const ScheduleEducationCenters: FC = () => {
    const [eduCenters, setEduCenters] = useState<EducationCenterType[]>([]);
    const { setCalendarData } = useScheduleCalendarContext();

    useEffect(() => {
        fetchEducationCenters().then((data) => {
            const centers = data
                .filter((x: EducationCenterType) => x.active)
                .map((centr: any) => ({ id: centr.id, name: centr.shortName }));
            setEduCenters(centers);
        });
    }, [setEduCenters]);

    const handleOnChange = (e: any) => {
        fetchSelectedCenter(e.target.value.toString()).then((data) => {
            setCalendarData((value) => ({ ...value, educationCenter: data }));
        });
    };

    const fetchSelectedCenter = async (id: string): Promise<EducationCenterType> => {
        const { data } = await axiosApiInstance.get(`centers/${id}`);

        return data;
    };

    return (
        <>
            <Box
                sx={{
                    '& .text_field__label': {
                        fontWeight: 400,
                        fontSize: '11px',
                        lineHeight: '14px',
                        color: palette.primary.grayBluish
                    }
                }}>
                <ShsSelectInput
                    sx={{
                        width: '280px',

                        '.MuiInputBase-root': {
                            height: '40px',
                            fontSize: '14px',
                            '.MuiInputBase-input': {
                                display: 'flex',
                                alignItems: 'center',
                                height: '40px',
                                paddingBottom: 0,
                                paddingTop: 0
                            }
                        }
                    }}
                    source="center"
                    label="Освітній центр"
                    choices={eduCenters}
                    onChange={handleOnChange}
                    filter=""
                    autoFocus
                    required
                />
            </Box>
        </>
    );
};
